export enum FlowState {
  Complete = 'complete',
  Error = 'error',
  Idle = 'idle',
  Loading = 'loading',
  LoadingHistory = 'loading-history',
  LoadingMore = 'loading-more',
  NoResults = 'no-results',
  NotFound = 'not-found',
  Pending = 'pending',
  Saving = 'saving',
  SendingToBusinessCentral = 'sending-to-business-central'
}
